import { useCallback } from 'react'
import {
  ApiGetWithToken,
	ApiDeleteWithToken,
	ApiPatchWithToken,
	ApiPostWithToken,
	useApiFetch,
	useApiPost
} from 'shared/api'
import {
	searchsDiseaseApi,
	searchsDiseaseApiBy
} from 'interface/endpoints'
import {
	SearchsDiseaseFormData,
  SearchsDiseaseResult,
  SearchsDiseaseResultList
} from './types'

export * from './types'

export const useListSearchsDisease = (
  searchId?: number | null
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
      if (!searchId) return null
      return ApiGetWithToken<SearchsDiseaseResultList>(
        apiAccess,
        searchsDiseaseApi(searchId, "/list"),
        cancelToken
  		)
    },
		[searchId]
	)
)

export const useGetSearchsDisease = (
  searchId?: number | null,
	searchsDiseaseId?: number | null
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
      if (!searchId || !searchsDiseaseId) return null
      return ApiGetWithToken<SearchsDiseaseResult>(
        apiAccess,
        searchsDiseaseApiBy(searchId, searchsDiseaseId),
        cancelToken
  		)
    },
		[searchId, searchsDiseaseId]
	)
)

export const usePostSearchsDisease = (
	searchId: number,
  callback?: {
    onPosted?: (result: SearchsDiseaseResult) => void
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError?: (reason: any) => void
  }
) => useApiPost<SearchsDiseaseFormData, SearchsDiseaseResult>(
	useCallback(
		(apiAccess, cancelToken, form, webSocketId) => {
			return ApiPostWithToken(
				apiAccess,
        searchsDiseaseApi(searchId),
				form,
				cancelToken,
				webSocketId
			)
		},
		[searchId]
	),
	useCallback(
		(result) => {
			if (callback?.onPosted) callback.onPosted(result)
			return result
		},
		[callback]
	),
	useCallback(
		(reason) => {
      if (callback?.onError) callback?.onError(reason)
		},
		[callback]
	)
)

export const useEditSearchsDisease = (
	searchId: number,
	searchsDiseaseId: number,
  callback?: {
    onEditted?: (result: SearchsDiseaseResult) => void
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError?: (reason: any) => void
  }
) => useApiPost<SearchsDiseaseFormData, SearchsDiseaseResult>(
	useCallback(
		(apiAccess, cancelToken, form, webSocketId) => {
			return ApiPatchWithToken(
				apiAccess,
        searchsDiseaseApiBy(searchId, searchsDiseaseId),
				form,
				cancelToken,
				webSocketId
			)
		},
		[searchId, searchsDiseaseId]
	),
	useCallback(
		(result) => {
			if (callback?.onEditted) callback.onEditted(result)
			return result
		},
		[callback]
	),
	useCallback(
		(reason) => {
      if (callback?.onError) callback?.onError(reason)
		},
		[callback]
	)
)

export const useSortSearchsDisease = (
	searchId: number,
  callback?: {
    onPosted?: () => void
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError?: (reason: any) => void
  }
) => useApiPost<number[], void>(
	useCallback(
		(apiAccess, cancelToken, ids, webSocketId) => {
			return ApiPostWithToken(
				apiAccess,
        searchsDiseaseApi(searchId, "/sort"),
				ids,
				cancelToken,
				webSocketId
			)
		},
		[searchId]
	),
	useCallback(
		() => {
			if (callback?.onPosted) callback.onPosted()
		},
		[callback]
	),
	useCallback(
		(reason) => {
      if (callback?.onError) callback?.onError(reason)
		},
		[callback]
	)
)

export const useRemoveSearchsDisease = (
	searchId: number, 
  callback?: {
    onDeleted?: (searchsDiseaseId: number) => void
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError?: (reason: any) => void
  }
) => useApiPost<number, number>(
	useCallback(
		(apiAccess, cancelToken, searchsDiseaseId, webSocketId) => {
			return ApiDeleteWithToken(
				apiAccess,
        searchsDiseaseApiBy(searchId, searchsDiseaseId),
				cancelToken,
				webSocketId
			)
		},
		[searchId]
	),
	useCallback(
		(result) => {
			if (callback?.onDeleted) callback.onDeleted(result)
			return result
		},
		[callback]
	),
	useCallback(
		(reason) => {
      if (callback?.onError) callback?.onError(reason)
		},
		[callback]
	)
)
